import React, { useState, useEffect } from "react";
import { Theme, useTheme } from "@mui/material/styles";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { arrayToMap } from "helper/catalogueHelpers";
import { get } from "lodash";


export interface commonObj{
  [key: string]: any
}
interface Props {
  uniqueKey?:string;
  itemTextKey?:string;
  widthVal?: number | string;
  boxWidth?: string;
  listData: commonObj[];
  preSelectedValue?:string;
  setValueOnMount?: boolean;
  placeholder?:string;
  parentFunc: (...args: any[]) => void; // need to change this to the type which we will get, when this dropdown is called in a component
  disabled?: boolean;
  dropdownProps?: any;
  customMargin?: string;
  iconColor?: string;
  SelectedValueClassName?: string;
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const DropDownContainer: React.FC<Props> = ({
  widthVal = 300,
  listData = [],
  parentFunc,
  boxWidth,
  uniqueKey = 'code',
  itemTextKey = 'name',
  preSelectedValue = '',
  setValueOnMount = true,
  placeholder = 'Select Option',
  disabled = false,
  dropdownProps = {},
  customMargin = '',
  iconColor = "#397EF5",
  SelectedValueClassName = "",
}) => {
  const [dropDownVal, setDropDownVal] = useState<string>("");
  const [dropDownList, setDropDownList] = useState<commonObj[]>(listData);
  const [optionsMap, setOptionsMap] = useState<any>({});
  const theme = useTheme();

  useEffect(() => {
    if (setValueOnMount) {
      dropDownList?.[0]?.[uniqueKey] && setDropDownVal(dropDownList[0][uniqueKey]);
      dropDownList?.[0]?.[uniqueKey] && parentFunc(dropDownList[0][uniqueKey]);
    }
    
  }, [setValueOnMount]);

  useEffect(()=>{
  setDropDownList(listData)
  },[listData])

  useEffect(() => {
    if (preSelectedValue || preSelectedValue === "") {
      setDropDownVal(preSelectedValue);
    }
  }, [preSelectedValue]);

  useEffect(()=>{
    setDropDownList(listData);
    if (setValueOnMount) {
      listData?.[0]?.[uniqueKey] && setDropDownVal(listData[0][uniqueKey]);
      listData?.[0]?.[uniqueKey] && parentFunc(listData[0][uniqueKey]);
    }
  }, [listData]);

  useEffect(() => {
    setOptionsMap(arrayToMap(listData,uniqueKey))
  },[listData, uniqueKey]);

  const handleChange = (event: SelectChangeEvent): void => {
    console.log("event: ", event);
    const {
      target: { value },
    } = event;
    setDropDownVal(value);
    parentFunc(value);
  };

  return (
    <div className={`dropdown-container ${boxWidth ? boxWidth : ""}`}>
      <FormControl sx={{ m: 1, width: widthVal || "100%", margin: customMargin || '8px'}}>
        <Select
          id="demo-multiple-name"
          className={"custom-select-class"}
          value={dropDownVal}
          onChange={handleChange}
          IconComponent={KeyboardArrowDownIcon}
          disabled={disabled}
          MenuProps={{
            ...dropdownProps
          }}
          sx={{
            borderRadius: "8px",
            height: "45px",
            '.MuiOutlinedInput-notchedOutline': {
              borderColor: '#D3D3D3',
            },
            '.MuiOutlinedInput-input':{
              fontWeight: "600",
              fontSize: "14px"
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#D3D3D3',
              borderWidth: '1px'
            },
            ".MuiSvgIcon-root ": {
              fill: iconColor,
            }
          }}
          displayEmpty
          renderValue={(value:any) => !!value ?
            <p className={`${SelectedValueClassName || ""} font-medium text-[16px]`}>{get(optionsMap, `${value}.${itemTextKey}`)}</p>:
            <p className="font-medium text-[15px] text-[#B2B2B2] overflow-hidden">{placeholder}</p>
          }
        >
          {dropDownList?.map((val, idx) => (
            <MenuItem
              key={idx}
              value={val[uniqueKey]}
              sx={{
                fontSize: "14px"
              }}
            >
              {val[itemTextKey]}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default DropDownContainer;
